import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { Pricing } from "../components/blocks";
import Seo from "../components/Seo";
import { serviceLd, breadcrumbLd } from "../seo/jsonld";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function Prix() {
  return (
    <div>
      <Seo path="/prix" jsonLd={[serviceLd, breadcrumbLd([{ name: "Accueil", path: "/" }, { name: "Prix", path: "/prix" }])]} />
      <Header />
      <main className="page">
        <div className="container">
          <Link to="/" className="back-link"><ArrowLeft size={15} /> Accueil</Link>
          <span className="eyebrow"><span className="sq" />Prix</span>
          <h1 className="h2" style={{ marginBottom: "0.5rem" }}>Prix et tarifs</h1>
          <p className="lead" style={{ marginBottom: "0.5rem", maxWidth: "60ch" }}>
            Comparez d'abord ce que ça remplace, puis choisissez votre plan. Facturé en Suisse, en CHF, sans engagement long.
          </p>
        </div>

        <Pricing />

        <div className="container" style={{ paddingBottom: "3rem" }}>
          <div className="glass card" data-testid="prix-internal-links" style={{ display: "flex", flexWrap: "wrap", gap: "1rem", justifyContent: "space-between", alignItems: "center" }}>
            <div>
              <h3 style={{ margin: "0 0 0.35rem", fontSize: "1.05rem" }}>Vous êtes une agence ou un revendeur ?</h3>
              <p className="muted" style={{ margin: 0, fontSize: "0.9rem", maxWidth: "52ch" }}>
                Revendez en marque blanche et calculez votre marge selon votre nombre de clients et votre propre tarif.
              </p>
            </div>
            <Link to="/agences" className="btn btn--ghost" data-testid="prix-to-agences">Voir l'offre agences <ArrowRight size={15} /></Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
